<div role="button" class="flex flex-row space-x-2 items-center">
  <span
          class="font-bold text-gray-800 cursor-pointer"
          [class.font-bold]="toggleState() === leftLabel() || toggleState() === false"
          [class.text-gray-800]="toggleState() === leftLabel() || toggleState() === false"
          [class.text-gray-500]="toggleState() !== leftLabel() && toggleState() !== false"
          (click)="selectLeft()">
    {{ leftLabel() }}
  </span>

    <div
            class="w-8 h-4 flex items-center rounded-full p-1 transition-colors duration-300 cursor-pointer"
            [class.bg-gray-500]="toggleState() === leftLabel() || toggleState() === false"
            [class.bg-primary-500]="toggleState() === rightLabel() || toggleState() === true"
            (click)="toggle()">
        <div
                class="w-3 h-3 bg-white rounded-full shadow transition-transform duration-300"
                [class.translate-x-4]="toggleState() === rightLabel() || toggleState() === true">
        </div>
    </div>

    <span
            class="cursor-pointer text-gray-500"
            [class.font-bold]="toggleState() === rightLabel() || toggleState() === true"
            [class.text-gray-800]="toggleState() === rightLabel() || toggleState() === true"
            [class.text-gray-500]="toggleState() !== rightLabel() && toggleState() !== true"
            (click)="selectRight()">
    {{ rightLabel() }}
  </span>
</div>
